<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <div class="pure-g" v-if="active">
          <div class="pure-u-4-5"><h3 class="responsive">{{step}}. Your account</h3></div>
          <div class="pure-u-1-5 text-right">
            <button v-if="active && canEdit" v-on:click="editOverride" class="link-lookalike">Close</button>
          </div>

          <div class="pure-u-1 spacing-20"></div>

          <form class="pure-u-1 pure-form pure-form-stacked font-14-sm" @submit.prevent="submit">
            <fieldset>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="fname">First name</label></div>
              <div class="pure-u-1 pure-u-sm-1-2"><input type="text" id="fname" class="pure-input-1"
                                                         v-model="user.fname">
                <ValidationErrors :errors="validationErrors.fname"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="lname">Last name</label></div>
              <div class="pure-u-1 pure-u-sm-1-2 padding-bottom-10"><input type="text" id="lname" class="pure-input-1"
                                                         v-model="user.lname">
                <div class="subtext">This will be the name associated with your account.</div>
                <ValidationErrors :errors="validationErrors.lname"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="email">Email</label></div>
              <div class="pure-u-1 pure-u-sm-1-2 padding-bottom-10"><input id="email" type="email" class="pure-input-1 margin-bottom-0"
                                                          v-model="user.email">
                <span v-if="emailError" class="subtext">Already a Tavour member? Need to <a class="link"
                                                                                            @click="$emit('login')">Login</a>?</span>
                <ValidationErrors :errors="validationErrors.email"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="password">Password</label></div>
              <div class="pure-u-1 pure-u-sm-1-2 "><input id="password" type="password"
                                                          class="pure-input-1 margin-bottom-0" v-model="user.password">
                <ValidationErrors :errors="validationErrors.password"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4 text-right-sm"><label for="password_confirmation">Confirm
                Password</label></div>
              <div class="pure-u-1 pure-u-sm-1-2 "><input id="password_confirmation" class="pure-input-1"
                                                          type="password" v-model="user.password_confirmation">
                <ValidationErrors :errors="validationErrors.password_confirmation"/>
              </div>

              <div class="pure-u-1 pure-u-sm-1-4"></div>

              <div class="pure-u-1 pure-u-sm-1-2">
                <Loading v-if="loading || isBusy"/>
                <button class="pure-button pure-button-primary block padding-10" type="submit">
                  {{buttonText}}
                </button>
                <div class="text-red" v-if="error">
                  {{ error }}
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <div v-else class="pure-g">
          <div class="pure-u-4-5"><h3 class="responsive">{{step}}. Your account</h3></div>

          <ul v-if="user.email" class="summary pure-u-1">
            <li>
              <div class="hidden-sm pure-u-sm-1-5 text-right">Name</div>
              <div class="pure-u-1 pure-u-sm-3-5 padding-left-10">{{ this.user.fname }} {{ this.user.lname }}</div>
            </li>
            <li>
              <div class="hidden-sm pure-u-sm-1-5 text-right">Email</div>
              <div class="pure-u-1 pure-u-sm-3-5 padding-left-10">{{ this.user.email }}</div>
            </li>
            <li>
              <div class="hidden-sm pure-u-sm-1-5 text-right">Password</div>
              <div class="pure-u-1 pure-u-sm-3-5 padding-left-10">************</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from '../helpers/Loading';
  import user from '../../lib/user';
  import store from '../../lib/store';
  import ValidationErrors from '../helpers/ValidationErrors';

  export default {
    name: 'UserCreator',
    components: {
      ValidationErrors,
      Loading,
    },
    props: ['active', 'step'],
    data() {
      return {
        loading: false,
        isBusy: false,
        validationErrors: {},
        canEdit: false,
        error: '',
        emailError: false,
        defaultErrorMsg: 'Something went wrong, please try again',
        user: {
          email: '',
          fname: '',
          lname: '',
          password: '',
          password_confirmation: '',
          referer: `https://subscriptions.tavour.com/${store.get('subscription')}/`,
        },
      };
    },
    created() {
      if (store.get('authToken')) {
        this.getUserInfo();
      }
    },
    watch: {
      active() {
        /* global ga */
        ga('send', 'pageview', `/${store.get('subscription')}/UserCreator`);

        if (store.get('authToken')) {
          this.getUserInfo();
        }
      },
    },
    methods: {
      createUser() {
        const body = Object.assign({}, this.user);
        body.subscribe_by_location = false;

        user.create(body, (err, res) => {
          this.isBusy = false;
          if (err) {
            if (res && res.statusCode === 422) {
              if (res.body.errors.email) {
                this.emailError = true;
              }
              this.validationErrors = res.body.errors;
            } else {
              this.error = this.defaultErrorMsg;
            }
          } else {
            store.set('authToken', res.body.user.auth_token);
            this.canEdit = true;
            this.$emit('success');
          }
        });
      },
      updateUser() {
        user.update(this.user, (err, res) => {
          this.isBusy = false;
          if (err) {
            this.parseErrors(res);
          } else {
            this.canEdit = true;
            this.editOverride();
          }
        });
      },
      getUserInfo() {
        this.loading = true;
        user.all((err, res) => {
          this.loading = false;
          this.isBusy = false;
          if (err) {
            this.parseErrors(res);
          } else if (res.body.user) {
            this.user.email = res.body.user.email;
            this.user.fname = res.body.user.fname;
            this.user.lname = res.body.user.lname;

            if (!this.canEdit) {
              this.canEdit = true;
              this.$emit('success');
            }
          }
        });
      },
      submit() {
        this.isBusy = true;
        this.error = '';
        if (this.canEdit) {
          this.updateUser();
        } else {
          this.createUser();
        }
      },
      edit() {
        this.$emit('editView', 'UserCreator');
      },
      editOverride() {
        this.$emit('editDone');
      },
      parseErrors(res) {
        if (res && res.statusCode === 422) {
          this.validationErrors = res.body.errors;
        } else {
          this.error = this.defaultErrorMsg;
        }
      },
    },
    computed: {
      buttonText() {
        if (this.canEdit) {
          return 'Update and continue';
        }
        return 'Next, where to send your beer';
      },
      disabled() {
        return this.isBusy || this.user.email === '' || this.user.password === '' || this.user.password_confirmation === '';
      },
    },
  };
</script>

<style scoped>

  label {
    margin-top: 10px;
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// UserCreator.vue?4df26113